function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PanelToolContainer } from './PanelToolContainer';
import { LayerCollapsePanel } from './LayerCollapsePanel';
var getLayerRowModels = function getLayerRowModels() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedLayerIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var controller = arguments.length > 2 ? arguments[2] : undefined;
  var opts = arguments.length > 3 ? arguments[3] : undefined;
  return layers.map(function (oskariLayer) {
    return {
      id: oskariLayer.getId(),
      model: oskariLayer,
      selected: selectedLayerIds.includes(oskariLayer.getId()),
      controller: controller,
      opts: opts
    };
  });
};
export var getCollapseItems = function getCollapseItems(groups, openGroupTitles, selectedLayerIds, opts, controller, panelProps) {
  if (!Array.isArray(groups)) {
    return [];
  }
  return groups.map(function (group) {
    var key = group.getId();
    var layerRows = getLayerRowModels(group.getLayers(), selectedLayerIds, controller, opts);
    // set group switch active if all layers in group are selected
    var allLayersOnMap = layerRows.length > 0 && layerRows.every(function (layer) {
      return selectedLayerIds.includes(layer.id);
    });
    // collapsible 'disabled' affects also to extra tools (cursor, style) and empty groups are shown only for admin
    // for now use always 'header' (not 'disabled' for !hasChildren)
    // const hasChildren = layerRows.length > 0 || group.getGroups().length > 0;
    var propsNeededForPanel = panelProps || {};
    return {
      key: key,
      label: group.getTitle(),
      className: "t_group gid_".concat(key),
      collapsible: 'header',
      extra: /*#__PURE__*/React.createElement(PanelToolContainer, {
        group: group,
        opts: opts,
        layerCount: group.getLayerCount(),
        controller: controller,
        allLayersOnMap: allLayersOnMap
      }),
      children: /*#__PURE__*/React.createElement(LayerCollapsePanel, _extends({
        key: key,
        trimmed: true,
        selectedLayerIds: selectedLayerIds,
        group: group,
        openGroupTitles: openGroupTitles,
        layerRows: layerRows,
        opts: opts,
        controller: controller
      }, propsNeededForPanel))
    };
  });
};